const sideBarMenu = [
  {
    id: "BOARD",
    title : "Board",
    route: "/dashboard",
    imgsrc: "layout.svg",
    imgname: "board",
    isActive : true
  },
  {
    id: "ANALYTICS",
    title : "Analytics",
    route: "/analytics",
    imgsrc: "database.svg",
    imgname: "analytics",
    isActive : false
  },
  {
    id: "SETTINGS",
    title : "Settings",
    route: "settings",
    imgsrc: "settings.svg",
    imgname: "settings",
    isActive : false
  },
];
export { sideBarMenu };
